import {faBell, faBellSlash} from '@fortawesome/free-solid-svg-icons';

export default [
    {
        feature: "notifications",
        to: "/settings/notifications",
        icon: faBell,
        title: "Notifications",
    },
    {
        feature: "notification_settings",
        to: "/settings/notification-settings",
        icon: faBellSlash,
        title: "Notification Settings",
    },
];